// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".adv_order_transporters_single[data-v-2bc9f439]{cursor:pointer}", "",{"version":3,"sources":["webpack://./assets/main/vue/AdvOrderTransportersSingle.vue"],"names":[],"mappings":"AACA,gDACE,cAAA","sourcesContent":["\r\n.adv_order_transporters_single {\r\n  cursor: pointer;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
